import styled from 'styled-components';

export const Background = styled.div`
  background-color: ${props => props.theme.colors.background.primary};
`;
